import React from 'react'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {useLanguage} from '../../../_gori/i18n/Metronici18n'
import LanguageToggle from '../../modules/common/components/LanguageToggle'
import {DEMO_INTRO_VIDEO_PATH, buildDemoVideoUrl} from '../../modules/demo/_demoConfig'
import {SeoHead} from '../../modules/seo'

const DemoIntroVideoPage: React.FC = () => {
  const navigate = useNavigate()
  const intl = useIntl()
  const {language} = useLanguage()

  const langCode = language.startsWith('ja') ? 'ja' : language.startsWith('zh') ? 'zh' : 'en'
  const videoUrl = buildDemoVideoUrl(DEMO_INTRO_VIDEO_PATH, langCode)

  const handleSkip = () => {
    navigate('/demo/topics')
  }

  const handleVideoEnd = () => {
    navigate('/demo/topics')
  }

  return (
    <div className='demo-intro-container'>
      <SeoHead />
      <img
        src='/media/logos/shipbae-gori-logo-black.svg'
        alt='ShipBae Powered By Gori.ai'
        className='img-fluid demo-intro-logo'
      />

      <video
        key={langCode}
        controls
        className='img-fluid demo-intro-video'
        onEnded={handleVideoEnd}
      >
        <source src={videoUrl} type='video/mp4' />
        Your browser does not support the video tag.
      </video>

      <div className='demo-intro-controls'>
        <button onClick={handleSkip} className='btn text-white demo-intro-skip-btn'>
          {intl.formatMessage({id: 'DEMO_INTRO_SKIP_BUTTON'})}
        </button>
      </div>

      <LanguageToggle allowedCodes={['en', 'zh']} />
    </div>
  )
}

export default DemoIntroVideoPage
